/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Beforeunload } from "react-beforeunload";
import { Button, Modal, Segment, Table } from "semantic-ui-react";
import { FormControlLabel, TextField } from "@mui/material";
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import { selectCurrentUserApiToken, selectCurrentUserId, selectCurrentUserName } from "../slices/currentUser/currentUserSlice";
import votePermissionCheck from "../functions/votePermissionCheckAPI";
import getFhirJsonForMyVotes from "../functions/getFhirJsonWithMyVotesAPI";
import { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import YesNoSwitch from "./YesNoSwitch";
import submitCodeSystemComment from "../resourceComponents/codeSystemResourceFunctions/submitCodeSystemComment";

const BallotAlertModal = ({ sendingInVotesState, ballotAlertModalOpenState, setBallotAlertModalOpenState }) => {
    const navigate = useNavigate();
    const modalClose = () => {
        setBallotAlertModalOpenState(false);
        if (sendingInVotesState.redirect) {
            //NEEDS TO RELOAD THIS PERSON'S VOTES
            navigate("/");
        }
    }

    return (
        <Modal
            style={{ width: "60%", padding: "16px", margin: "16px" }}
            centered={false}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={ballotAlertModalOpenState}
            closeOnEscape
            closeOnDimmerClick
            onClose={modalClose}
            content={<div style={{ whiteSpace: "pre-wrap" }}>
                <Button style={{ padding: "6px", position: "absolute", top: "8px", right: "8px" }}
                    className="formButton negative" content="✖"
                    onClick={() => { modalClose(); }}
                />
                <h2>{sendingInVotesState.message}</h2>
            </div>}
        />
    )
}

const iterateThroughTermsToBeVotedOn = (parentConcept, myvotesdict, systemId, systemTitle, systemName, terms) => {
    for (let conceptIndex in parentConcept.concept) {
        let concept = parentConcept.concept[conceptIndex];
        let openForVoting;
        let commentsForApplication;
        for (let propertyIndex in concept.property) {
            let property = concept.property[propertyIndex];
            if (property.valueString) {
                if (property.code === "open-for-voting") {
                    openForVoting = property.valueString;
                } else if (property.code === "comment") {
                    commentsForApplication = property.valueString;
                }
            }
        }
        if (openForVoting) {
            let alternativeTerms = [];
            for (let designationIndex in concept.designation) {
                let designation = concept.designation[designationIndex];
                if (designation.value && (designation.use?.display === "Alternative term" ||
                    designation.use?.display === "Synonym (core metadata concept)" ||
                    designation.use?.code === "900000000000013009")) {
                    alternativeTerms.push(designation.value);
                }
            }
            let term = {
                "code": concept.code, "display": concept.display, "definition": concept.definition,
                "alternativeTerms": alternativeTerms, "commentsForApplication": commentsForApplication,
                "openForVotingString": openForVoting,
                "systemId": systemId, "systemTitle": systemTitle, "systemName": systemName,
                "myvotes": [], "latestValidVote": {}, "voteLabel": "", "voteComment": ""
            };

            term["myvotes"] = myvotesdict[concept.code];
            let latestValidVote = {};
            let latestValidVoteDate;
            if (term["myvotes"]?.length > 0) {
                latestValidVote = term["myvotes"][0];
                latestValidVoteDate = new Date(term["myvotes"][0]["datesubmitted"]);
            }
            let openForVotingDate = new Date(openForVoting);
            if (latestValidVoteDate >= openForVotingDate) { //date date comparison
                term["latestValidVote"] = latestValidVote;
                if (term["latestValidVote"]["vote"] !== undefined) {
                    if (term["latestValidVote"]["vote"]) {
                        term["voteLabel"] = "Yes";
                    } else {
                        term["voteLabel"] = "No";
                    }
                }
                if (term["latestValidVote"].summary) {
                    term["voteComment"] = term["latestValidVote"].summary;
                }
            }

            terms.push(term);
        }
        if (concept.concept) {
            terms = iterateThroughTermsToBeVotedOn(concept, myvotesdict, systemId, systemTitle, systemName, terms);
        }
    }
    return terms;
}

const getTermsToBeVotedOn = (json, myvotesdict) => {
    let terms = [];
    let systemId = json.id;
    let systemTitle = json.title;
    let systemName = json.name;
    terms = iterateThroughTermsToBeVotedOn(json, myvotesdict, systemId, systemTitle, systemName, terms);
    return terms;
}

// eslint-disable-next-line no-empty-pattern
const MyBallotPage = ({ }) => {
    const dispatch = useDispatch();

    const apiToken = useSelector(selectCurrentUserApiToken);
    const userId = useSelector(selectCurrentUserId);
    const userName = useSelector(selectCurrentUserName);

    const codeSystemsToWatch = [27270, 27833];

    const [codeSystemsTermsReadyForVoteState, setCodeSystemsTermsReadyForVoteState] = useState({});
    const [numberOfVotingGroupsState, setNumberOfVotingGroupsState] = useState(null);
    //const [loadedState, setLoadedState] = useState(false);
    const [sendingInVotesState, setSendingInVotesState] = useState({ loading: false, message: "", redirect: false });
    const [ballotAlertModalOpenState, setBallotAlertModalOpenState] = useState(false);

    const [changeMadeToMyBallot, setChangeMadeToMyBallot] = useState(false);

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR My Ballot"));
        dispatch(changeTool("FEvIR®: My Ballot"));
    }, []);

    useEffect(() => {
        if (sendingInVotesState.message) {
            setBallotAlertModalOpenState(true);
        }
    }, [sendingInVotesState]);

    const loadCodeSystemsTermsReadyForVote = async () => {
        dispatch(globalLoadingOn());
        //setLoadedState(true);
        let numberOfVotingGroups = 0;
        let codeSystemsTermsReadyForVote = {};
        for (let index in codeSystemsToWatch) {
            let codeSystemId = codeSystemsToWatch[index];

            //CHECKS TO SEE IF USER HAS PERMISSION TO VOTE IN CODE SYSTEM
            let votePermissionResponse = false;

            let votePermissionCheckResponse = await votePermissionCheck(codeSystemId, apiToken);
            if (votePermissionCheckResponse?.votepermission === true) {
                votePermissionResponse = true;
            }

            let response = await getFhirJsonForMyVotes(codeSystemId, apiToken);
            if (response?.success && response.fhirjson) {

                let json = response.fhirjson;

                codeSystemsTermsReadyForVote[codeSystemId] = {};
                codeSystemsTermsReadyForVote[codeSystemId]["name"] = json.name;
                codeSystemsTermsReadyForVote[codeSystemId]["title"] = json.title;
                codeSystemsTermsReadyForVote[codeSystemId]["changeMadeToCodeSystem"] = false;
                if (votePermissionResponse) {
                    let termsToBeVotedOn = getTermsToBeVotedOn(json, response.myvotesdict);
                    codeSystemsTermsReadyForVote[codeSystemId]["termsToBeVotedOn"] = termsToBeVotedOn;
                    codeSystemsTermsReadyForVote[codeSystemId]["joinedGroup"] = true;
                    numberOfVotingGroups += 1;
                } else {
                    codeSystemsTermsReadyForVote[codeSystemId]["joinedGroup"] = false;
                }
            }

        }
        setCodeSystemsTermsReadyForVoteState(codeSystemsTermsReadyForVote);
        setNumberOfVotingGroupsState(numberOfVotingGroups);
        dispatch(globalLoadingOff());
    };

    useEffect(() => {
        if (apiToken) { //&& loadedState === false
            loadCodeSystemsTermsReadyForVote();
        }
    }, [apiToken]);

    const submitVotes = async (codeSystemId, setSendingInVotesState, codeSystemSet) => {
        dispatch(globalLoadingOn());
        setSendingInVotesState({ loading: true, message: "", redirect: false });
        setCodeSystemsTermsReadyForVoteState(prevState => {
            let newObj = JSON.parse(JSON.stringify(prevState[codeSystemId]));
            newObj["changeMadeToCodeSystem"] = false;
            return { ...prevState, [codeSystemId]: newObj }
        });

        let noProblems = true;
        let alertMessage = "";

        //Validation loop
        for (let termIndex in codeSystemSet.termsToBeVotedOn) {
            let term = codeSystemSet.termsToBeVotedOn[termIndex];
            if (term.changeMade) {
                if (term.voteLabel) {
                    if (term.voteLabel === "No") {
                        if (term.voteComment) {
                            //OK to pass
                        } else {
                            alertMessage += "All No votes must have a comment. Please check: " + term.display + "\n";
                        }
                    }
                } else {
                    alertMessage += "Comment added, but Yes or No were not selected for: " + term.display + "\n";
                }
            }
        }
        if (alertMessage) {
            alertMessage = "You cannot submit votes until correcting the following:\n\n" + alertMessage;
            //alert(alertMessage);
        } else {
            //Submit loop
            let votes = [];
            let voteDisplays = []
            let votesSubmitted = [];
            let votesFailed = [];
            for (let termIndex in codeSystemSet.termsToBeVotedOn) {
                let term = codeSystemSet.termsToBeVotedOn[termIndex];
                if (term.changeMade) {
                    let termVoteBoolean = term.voteLabel.toLowerCase() !== "no";
                    let termCopy = JSON.parse(JSON.stringify(term));
                    delete termCopy.comments;
                    delete termCopy.votes;
                    delete termCopy.myvotes;
                    delete termCopy.latestValidVote;
                    delete termCopy.systemId;
                    delete termCopy.systemTitle;
                    delete termCopy.systemName;
                    delete termCopy.voteLabel;
                    delete termCopy.voteComment;
                    delete termCopy.changeMade;
                    let vote = {
                        'codesystem': codeSystemId,
                        'termcode': term.code,
                        'termconcept': termCopy,
                        'vote': termVoteBoolean,  //How the user voted true/false or yes/no
                        'votechoice': term.voteLabel,   //For something other than true/false or yes/no, but I'll record the yes/no anyways.
                        'votecomment': term.voteComment
                    };
                    votes.push(vote);
                    voteDisplays.push(term.display);
                }
            }
            if (votes.length > 0) {
                let response = await submitCodeSystemComment(apiToken, userId, userName, "vote", codeSystemId,
                    codeSystemSet.title, null, null, null, null, null, null,
                    null, false, undefined, votes);
                if (response?.success) {
                    votesSubmitted = voteDisplays;
                } else {
                    votesFailed = voteDisplays;
                }
            }
            if (noProblems) {
                let redirect = true;
                setCodeSystemsTermsReadyForVoteState(prevState => {
                    let newObj = JSON.parse(JSON.stringify(prevState[codeSystemId]));
                    newObj["changeMadeToCodeSystem"] = false;
                    for (let termIndex in newObj["termsToBeVotedOn"]) {
                        newObj["termsToBeVotedOn"][termIndex]["changeMade"] = false;
                    }
                    return { ...prevState, [codeSystemId]: newObj }
                });
                for (let codeSystemKey in codeSystemsTermsReadyForVoteState) {
                    if (codeSystemKey !== codeSystemId &&
                        codeSystemsTermsReadyForVoteState[codeSystemKey]["changeMadeToCodeSystem"]) {
                        redirect = false;
                        break;
                    }
                }
                dispatch(globalLoadingOff()); //Just in case this function's component is unmounted before this function can complete
                setSendingInVotesState({
                    loading: false,
                    message: "All votes submitted: " + votesSubmitted.join(', '),
                    redirect: redirect
                });
                if (redirect) {
                    setChangeMadeToMyBallot(false);
                    //navigate("/");
                }
            } else {
                alertMessage = "Not all votes submitted. These terms had a problem being submitted: " + votesFailed.join(', ');
            }
        }
        dispatch(globalLoadingOff());
        if (alertMessage) {
            setSendingInVotesState({ loading: false, message: alertMessage, redirect: false });
            setCodeSystemsTermsReadyForVoteState(prevState => {
                let newObj = JSON.parse(JSON.stringify(prevState[codeSystemId]));
                newObj["changeMadeToCodeSystem"] = true;
                return { ...prevState, [codeSystemId]: newObj }
            });
        }
    }

    return (
        <div>
            {(apiToken || userId === "1") &&
                <>
                    {/*Loading spinner when a user submits their votes until it's fully submitted*/}
                    {/*(!loadedState || sendingInVotesState.loading)
                &&
                <Dimmer className={"loadingDimmer"} active inverted>
                    <Loader inverted>Loading</Loader>
                </Dimmer>
            */}
                    <BallotAlertModal sendingInVotesState={sendingInVotesState}
                        ballotAlertModalOpenState={ballotAlertModalOpenState}
                        setBallotAlertModalOpenState={setBallotAlertModalOpenState} />
                    <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                        <div>
                            {changeMadeToMyBallot && <Beforeunload onBeforeunload={(event) => { event.preventDefault(); }} />}
                            {apiToken ?
                                <>
                                    {numberOfVotingGroupsState === 0 ?
                                        <h2>You are not signed up with any voting group.</h2>
                                        :
                                        <>
                                            {Object.keys(codeSystemsTermsReadyForVoteState).map((codeSystemId, index) => {
                                                let codeSystemSet = codeSystemsTermsReadyForVoteState[codeSystemId];
                                                let termsAvailable = codeSystemSet.termsToBeVotedOn?.length > 0;
                                                return <div key={index}>
                                                    {/*<h2>{codeSystemSet.title}</h2>*/}
                                                    {codeSystemSet.joinedGroup ?
                                                        <>
                                                            <Table>
                                                                <Table.Header>
                                                                    <Table.Row>
                                                                        <Table.HeaderCell colSpan="6" style={{ backgroundColor: "#F0F4FC" }}>
                                                                            <table className="noStyleTable" style={{ width: "100%" }}><tbody><tr>
                                                                                <td style={{ padding: "0px", margin: "0px" }}>
                                                                                    <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                                                                                        {codeSystemSet.title}
                                                                                    </span>
                                                                                </td>
                                                                                <td style={{
                                                                                    textAlign: "right", padding: "0px",
                                                                                    margin: "0px", width: "125px"
                                                                                }}>
                                                                                    <Button className="formButton"
                                                                                        content="Submit Votes"
                                                                                        style={{ color: "#000000" }}
                                                                                        compact
                                                                                        disabled={!codeSystemSet.changeMadeToCodeSystem}
                                                                                        onClick={() => {
                                                                                            submitVotes(codeSystemId, setSendingInVotesState, codeSystemSet);
                                                                                        }} />
                                                                                </td>
                                                                            </tr>
                                                                            </tbody>
                                                                            </table>
                                                                        </Table.HeaderCell>
                                                                    </Table.Row>
                                                                    <Table.Row>
                                                                        <Table.HeaderCell>Term</Table.HeaderCell>
                                                                        <Table.HeaderCell>Definition</Table.HeaderCell>
                                                                        <Table.HeaderCell>Alternative Terms<br />(if any)</Table.HeaderCell>
                                                                        <Table.HeaderCell>Comment for application<br />(if any)</Table.HeaderCell>
                                                                        <Table.HeaderCell>Vote</Table.HeaderCell>
                                                                        <Table.HeaderCell>Comment</Table.HeaderCell>
                                                                    </Table.Row>
                                                                </Table.Header>
                                                                <Table.Body>
                                                                    {termsAvailable ? codeSystemSet.termsToBeVotedOn.map((term, termIndex) => {
                                                                        //let latestValidVote = term.latestValidVote;
                                                                        let rowStyle = {};
                                                                        if (term.voteLabel === "Yes") {
                                                                            rowStyle["backgroundColor"] = "#00FF0012";
                                                                        } else if (term.voteLabel === "No") {
                                                                            rowStyle["backgroundColor"] = "#FF000012";
                                                                        }
                                                                        return <Table.Row key={termIndex} style={rowStyle}>
                                                                            <Table.Cell style={{ verticalAlign: "top" }}>
                                                                                {term.code ?
                                                                                    <a href={"/resources/CodeSystem/" + codeSystemId.toString() + "#" + term.code}
                                                                                        target="_blank" rel="noopener noreferrer">{term.display}</a>
                                                                                    :
                                                                                    term.display}
                                                                            </Table.Cell>
                                                                            <Table.Cell style={{ verticalAlign: "top" }}>{term.definition}</Table.Cell>
                                                                            <Table.Cell style={{ verticalAlign: "top", paddingLeft: "0px" }}>
                                                                                <ul style={{ margin: "20px" }}>
                                                                                    {term.alternativeTerms.map((alternativeTerm, alternativeTermIndex) => {
                                                                                        return <li key={alternativeTermIndex}>{alternativeTerm}</li>
                                                                                    })}
                                                                                </ul>
                                                                            </Table.Cell>
                                                                            <Table.Cell style={{ verticalAlign: "top", whiteSpace: "pre-wrap" }}>
                                                                                <DisplayFromFHIRMarkdown markdown={term.commentsForApplication} />
                                                                            </Table.Cell>
                                                                            <Table.Cell style={{ align: "center", padding: "0px" }}>
                                                                                {term.voteLabel ?
                                                                                    <>
                                                                                        <FormControlLabel className="yesNoSliderLabel"
                                                                                            style={{ marginLeft: "0px", marginRight: "0px", width: "100%" }}
                                                                                            control={<YesNoSwitch className="yesNoSliderSwitch"
                                                                                                value={term.voteLabel}
                                                                                                checked={term.voteLabel === "Yes" ? true : false}
                                                                                                onClick={(e, data) => {
                                                                                                    setCodeSystemsTermsReadyForVoteState(prevState => {
                                                                                                        let newObj = JSON.parse(JSON.stringify(prevState[codeSystemId]));

                                                                                                        if (term.voteLabel === "No") {
                                                                                                            newObj["termsToBeVotedOn"][termIndex]["voteLabel"] = "Yes";
                                                                                                        } else {
                                                                                                            newObj["termsToBeVotedOn"][termIndex]["voteLabel"] = "No";
                                                                                                        }
                                                                                                        newObj["termsToBeVotedOn"][termIndex]["changeMade"] = true;
                                                                                                        newObj["changeMadeToCodeSystem"] = true;
                                                                                                        return { ...prevState, [codeSystemId]: newObj }
                                                                                                    });
                                                                                                    setChangeMadeToMyBallot(true);
                                                                                                }} />}
                                                                                        />
                                                                                    </>
                                                                                    :
                                                                                    <div style={{ align: "center", width: "100%", padding: "8px" }}>
                                                                                        <Button className="formButton positive" content="Yes" compact
                                                                                            style={{ width: "48px", paddingLeft: "0px", paddingRight: "0px", margin: "0px" }}
                                                                                            onClick={() => {
                                                                                                setCodeSystemsTermsReadyForVoteState(prevState => {
                                                                                                    let newObj = JSON.parse(JSON.stringify(prevState[codeSystemId]));
                                                                                                    newObj["termsToBeVotedOn"][termIndex]["voteLabel"] = "Yes";
                                                                                                    newObj["termsToBeVotedOn"][termIndex]["changeMade"] = true;
                                                                                                    newObj["changeMadeToCodeSystem"] = true;
                                                                                                    return { ...prevState, [codeSystemId]: newObj }
                                                                                                });
                                                                                                setChangeMadeToMyBallot(true);
                                                                                            }} />
                                                                                        <br />
                                                                                        <div style={{ paddingTop: "8px" }} />
                                                                                        <Button className="formButton negative" content="No" compact
                                                                                            style={{ width: "48px", paddingLeft: "0px", paddingRight: "0px", margin: "0px" }}
                                                                                            onClick={() => {
                                                                                                setCodeSystemsTermsReadyForVoteState(prevState => {
                                                                                                    let newObj = JSON.parse(JSON.stringify(prevState[codeSystemId]));
                                                                                                    newObj["termsToBeVotedOn"][termIndex]["voteLabel"] = "No";
                                                                                                    newObj["termsToBeVotedOn"][termIndex]["changeMade"] = true;
                                                                                                    newObj["changeMadeToCodeSystem"] = true;
                                                                                                    return { ...prevState, [codeSystemId]: newObj }
                                                                                                });
                                                                                                setChangeMadeToMyBallot(true);
                                                                                            }} />
                                                                                    </div>
                                                                                }
                                                                            </Table.Cell>
                                                                            <Table.Cell style={{ verticalAlign: "top" }}>
                                                                                <TextField style={{ height: "100%" }} multiline
                                                                                    className="inputField voteCommentField" type='text' label={'Vote Comment'} size="small"
                                                                                    variant='outlined' value={term.voteComment}
                                                                                    onChange={(e) => {
                                                                                        setCodeSystemsTermsReadyForVoteState(prevState => {
                                                                                            let newObj = JSON.parse(JSON.stringify(prevState[codeSystemId]));
                                                                                            newObj["termsToBeVotedOn"][termIndex]["voteComment"] = e.target.value;
                                                                                            newObj["termsToBeVotedOn"][termIndex]["changeMade"] = true;
                                                                                            newObj["changeMadeToCodeSystem"] = true;
                                                                                            return { ...prevState, [codeSystemId]: newObj }
                                                                                        });
                                                                                        setChangeMadeToMyBallot(true);
                                                                                    }}

                                                                                />
                                                                            </Table.Cell>
                                                                        </Table.Row>
                                                                    })
                                                                        :
                                                                        <Table.Row>
                                                                            <Table.Cell colSpan="6" style={{ textAlign: "center" }}>
                                                                                <h4>There are no terms open for vote at this time.</h4>
                                                                            </Table.Cell>
                                                                        </Table.Row>
                                                                    }
                                                                    <Table.Row>
                                                                        <Table.Cell colSpan="6" style={{ textAlign: "right" }}>
                                                                            <Button className="formButton" content="Submit Votes"
                                                                                style={{ color: "#000000" }} compact
                                                                                disabled={!codeSystemSet.changeMadeToCodeSystem}
                                                                                onClick={() => {
                                                                                    submitVotes(codeSystemId, setSendingInVotesState, codeSystemSet);
                                                                                }} />
                                                                        </Table.Cell>
                                                                    </Table.Row>
                                                                </Table.Body>
                                                            </Table>
                                                            <div style={{ width: "100%", textAlign: "right" }}>
                                                                {termsAvailable && <><br /></>}
                                                            </div>
                                                        </>
                                                        :
                                                        <>{/*<h3>For voting privileges, please join the {codeSystemSet.title} group.</h3>*/}</>
                                                    }
                                                    <br /><br />
                                                </div>
                                            })}
                                        </>
                                    }
                                </>
                                :
                                <div>
                                    <h1>Please login to use this feature.</h1>
                                    <p>(If you do not have an account click Sign In and log in with your Google Account.)</p>
                                </div>
                            }
                        </div>
                    </Segment>
                </>}
        </div>
    );
};

export default MyBallotPage;